export default { sha: '487a6573a608c4cd0b235b15694f78501c5fb2a9', buildNumber: 'undefined' }
